const initialState = [
  { name: 'car', description: 'Ваш автомобиль', mainTitle: 'Выберите Ваш автомобиль', subTitle: '' },
  {
    name: 'engine',
    description: 'Двигатель и трансмиссия',
    mainTitle: 'Укажите тип двигателя и трансмиссии',
    subTitle: '',
    isLarge: true,
    type: '',
    age: 0,
    mileage: 0,
  },
  { name: 'map-pin-menu', description: 'Сервисный центр', mainTitle: 'Выберите сервисный центр', subTitle: '' },
  {
    name: 'money',
    description: 'Расчет стоимости',
    mainTitle: 'Делаем расчёт стоимости работ и запасных частей',
    subTitle: '',
  },
  { name: 'user', description: 'Контактные данные', mainTitle: 'Заполните контактные данные', subTitle: '' },
  { name: 'calendar', description: 'Запись на сервис', mainTitle: 'Выберете дату и время для записи', subTitle: '' },
];

export default initialState;
